import PhotoAPI from '../../api/photo.js'

export const photo = {
    namespaced: true,
    state: {
        photos: [],
    },
    actions: {
        load: ({ commit }, id) =>
            PhotoAPI.PHOTOS(id)
                .then(response => commit('PHOTOS', response.data))
                .catch(error => console.log(error)),
        add: ({ commit }, photo) => commit('addPhoto', photo),
        THUMB: ({ }, photo) => new Promise((resolve) => PhotoAPI.THUMB(photo).then(response => resolve(window.URL.createObjectURL(response.data)))),
        PHOTO: ({ }, photo) => new Promise((resolve) => PhotoAPI.PHOTO(photo).then(response => resolve(window.URL.createObjectURL(response.data)))),
        destroy: ({ }, data) => PhotoAPI.destroy(data),

    },

    mutations: {
        PHOTOS: (state, photos) => state.photos = photos,

        addPhoto(state, photo) {
            state.photos.push(photo)
        }
    },

}
